import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import $ from 'jquery';

import './Popover.css';
import { Portal } from 'react-portal';

const numberOrString = PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]);

export default class Popover extends React.Component {
  static propTypes = {
    top: numberOrString,
    left: numberOrString,
    height: numberOrString,
    right: numberOrString,
    width: numberOrString,
    overflow: PropTypes.string,
    maxHeight: numberOrString,
    maxWidth: numberOrString,
    paddingLeft: numberOrString,
    children: PropTypes.node.isRequired,
    onClose: PropTypes.func.isRequired,
    noBackground: PropTypes.bool,
  };

  state = {
    styleOverrides: {},
  };

  componentDidMount() {
    if (this.props.noBackground) {
      document.addEventListener('click', this.onBackgroundClick, true);
    }
  }

  componentWillUnmount() {
    if (this.props.noBackground) {
      document.removeEventListener('click', this.onBackgroundClick, true);
    }
  }

  onBackgroundClick = (e) => {
    if ($(e.target).closest('[name="OldPopover"]').length === 0) {
      e.stopPropagation();
      this.props.onClose();
    }
  };

  onRef = (node: HTMLDivElement) => {
    if (!node) {
      if (Object.keys(this.state.styleOverrides).length) {
        this.setState({ styleOverrides: {} });
      }
      return;
    }

    if (this.props.getRef) {
      this.props.getRef(node);
    }

    let rect = node.getBoundingClientRect();
    if (!rect.width) {
      rect = node.firstElementChild.getBoundingClientRect();
    }

    const styleOverrides = {};

    const rdiff = rect.right - window.innerWidth;
    if (rdiff > 0) {
      if (rect.width > window.innerWidth) {
        styleOverrides.width = window.innerWidth - 10;
        styleOverrides.left = 5;
      } else {
        styleOverrides.left = this.props.left - rdiff - 5;
      }

      this.setState({ styleOverrides });
    } else if (rect.left < 0) {
      styleOverrides.width = window.innerWidth - 10;
      styleOverrides.left = 5;
      this.setState({ styleOverrides });
    }
  };

  render() {
    let { top, left, height, right, width, maxWidth, overflow, maxHeight, paddingLeft, children, onClose, noBackground } = this.props;
    const { styleOverrides } = this.state;
    const popOverBackgroundStyle = {
      zIndex: 999,
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
    };

    const popoverStyle = {
      top,
      left,
      right,
      width,
      height,
      overflow: overflow,
      maxHeight: maxHeight,
      paddingLeft: paddingLeft,
      maxWidth: maxWidth,
      boxShadow: '0 15px 30px -10px rgba(0,0,0,0.20)',
      background: 'var(--primary-header-bg)',
      position: 'fixed',
      zIndex: 9999,
      borderRadius: '3px',
      ...styleOverrides,
    };

    return (
      <Portal defaultOpen = {true} closeOnEsc>
       <div
          className={classNames({ 'style-overrides': Object.keys(styleOverrides).length > 0 })}
          style={{ cursor: 'default' }}
          name="OldPopover">
          {noBackground ? null : <div onClick={onClose} style={popOverBackgroundStyle} />}
          <div className="wrapper" style={popoverStyle} ref={this.onRef}>
            {children}
          </div>
        </div>
      </Portal>
     
    );
  }
}
